<template>
  <footer
    class="footer"
    :class="{
      [`footer-${type}`]: type,
      [`footer-${size}`]: size
    }"
    :data-background-color="backgroundColor">
    <div class="container">
      <nav>
        <ul>
          <li>
            <router-link to="/">
              Home
            </router-link>
          </li>
          <li>
            <router-link to="/#about">
              About Us
            </router-link>
          </li>
          <li>
            <router-link to="/products">
              Products
            </router-link>
          </li>
          <li>
            <router-link to="/#contact">
              Contact
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Development by
        <a href="https://www.exnihilodev.com" target="_blank"
          >Ex Nihilo Studios, LLC</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
    size: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
